export const CALIBRATION_WIZARD_CONTENT = {
  Welcome: 0,
  CheckScales: 1,
  CalibrateScale: 2,
};

export const LOAD_CELL_SENSOR = {
  Sample: 0,
  Buffer: 1,
};

export const STEP_WIZARD = {
  NoTubeCalibration: 0,
  SampleTubeCalibration: 1,
  BufferTubeCalibration: 2,
  ResultCalibration: 3,
};

export const POOLING_PARAM_LABEL = {
  VOLUME: 'Volume',
  IMAGES: 'Images',
  TEXT: 'Text',
  FIELD_LABEL: 'Label',
};
export const VOLUME_SENSOR_LABEL = {
  Protein: 'Protein',
  Buffer: 'Buffer',
  Scale: 'Scale',
};

export const DEFAULT_RINSING_DURATION = '2'; // in minutes
export const DEFAULT_CLEANING_TYPE = 'CompleteCleaning';
